import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CpdTimelineChart = ({ data }) => {
    return (
        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700 h-80">
            <h3 className="text-lg font-bold text-blue-800 dark:text-blue-300 mb-4">CPD Timeline (This Year)</h3>
            <ResponsiveContainer width="100%" height="90%">
                <LineChart data={data} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.1} />
                    <XAxis dataKey="month" stroke="#9ca3af" fontSize={12} />
                    <YAxis label={{ value: 'Hours', angle: -90, position: 'insideLeft', fill: '#9ca3af' }} stroke="#9ca3af" fontSize={12} />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#1f2937',
                            borderColor: '#374151',
                        }}
                        itemStyle={{ color: '#e5e5e5' }}
                        labelStyle={{ color: '#ffffff', fontWeight: 'bold' }}
                    />
                    {/* MODIFICATION: Repositioned and relabeled the legend */}
                    <Legend 
                        verticalAlign="top" 
                        align="right" 
                        formatter={() => <span className="text-gray-600 dark:text-gray-300">CPD Hours</span>}
                    />
                    <Line type="monotone" dataKey="hours" stroke="#38bdf8" strokeWidth={2} activeDot={{ r: 8 }} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CpdTimelineChart;